import { Box, Button, FormikField as Field, Input } from '@betterment/samba-react';
import { Form, Formik } from 'formik';
import { useNavigate, useSearchParams } from 'react-router-dom';
import * as Yup from 'yup';

import { JOINT_ACCOUNT_FLOW_CONFIG, useJointAccountStep } from './JointAccountFlow';

import { WorkflowLayout } from '../../../Shared/layout/WorkflowLayout';

type FormValues = Yup.InferType<(typeof JOINT_ACCOUNT_FLOW_CONFIG)['user_details']['schema']>;

export const UserDetails: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const returnTo = searchParams.get('returnTo');

  const { values, commit } = useJointAccountStep('user_details');

  const initialValues: FormValues = {
    firstName: values?.firstName || '',
    lastName: values?.lastName || '',
    phoneNumber: values?.phoneNumber || '',
  };

  const handleSubmit = (formValues: FormValues) => {
    commit(formValues);

    void navigate(`/add_account/self_directed_investing/investing_experience`);
  };

  return (
    <WorkflowLayout
      pageTitle="User search"
      workflowTitle=""
      onBack={() => navigate(-1)}
      onClose={() => (returnTo ? navigate(returnTo) : navigate('/'))}
      size="small"
    >
      <Box
        css={{
          display: 'grid',
          gap: 'space.200',
        }}
      >
        <h1>Secondary account holder details</h1>
        <Formik
          onSubmit={handleSubmit}
          initialValues={initialValues}
          validationSchema={JOINT_ACCOUNT_FLOW_CONFIG.user_details.schema}
          validateOnChange={false}
          validateOnBlur={false}
          enableReinitialize={true}
        >
          <Form>
            <Box css={{ display: 'grid', gap: 'space.200', maxWidth: '400px' }}>
              <Field name="firstName">
                <Field.Label>First Name</Field.Label>
                <Field.Control>
                  <Input />
                </Field.Control>
                <Field.ErrorMessage />
              </Field>
              <Field name="lastName">
                <Field.Label>Last Name</Field.Label>
                <Field.Control>
                  <Input />
                </Field.Control>
                <Field.ErrorMessage />
              </Field>
              <Field name="phoneNumber">
                <Field.Label>Phone Number</Field.Label>
                <Field.Control>
                  <Input />
                </Field.Control>
                <Field.ErrorMessage />
              </Field>

              <Box css={{ display: 'flex', gap: 'space.200' }}>
                <Button type="submit" variant="solidPrimary" css={{ width: 'fit-content' }}>
                  Next
                </Button>
              </Box>
            </Box>
          </Form>
        </Formik>
      </Box>
    </WorkflowLayout>
  );
};
